import type {PointerEvent} from 'react';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import type {IconSize} from '@Components/icon-v2/icon.types';

export enum CarouselDirection {
  HORIZONTAL,
  VERTICAL,
}

export enum CarouselClickBehaviour {
  ADD = 'add',
  SELECT = 'select',
}

export interface CarouselItemData {
  width: number;
  height: number;
  /** The width is a fixed card width (audio / voice / CTA cards) — exempt from maxItemAspectRatio clamping. */
  hasFixedWidth?: boolean;
  gridItemData: GridItemStorage;
}

export interface CarouselProps {
  items: CarouselItemData[];
  onNext?: () => void;
  onPrev?: () => void;
  height?: number;
  selectionGroupId?: string;
  maxSelectionNumber?: number;
  onSingleItemClick?: (items: GridItemStorage[]) => Promise<void>;
  onCarouselItemClicked?: (carouselItemID: string) => void;
  clickBehaviour?: CarouselClickBehaviour;
  isItemDraggable?: boolean;
  onItemPointerDown?: (item: GridItemStorage, e: PointerEvent<HTMLElement>) => void;
  nextBtnRightPositioning?: number;
  prevBtnLeftPositioning?: number;
  gridID?: string;
  controlButtonIconSize?: IconSize;
  controlButtonTopPositioning?: number;
  /** Caps tile width at height × this ratio; a clamped item's media letterboxes inside the tile instead of cover-cropping. */
  maxItemAspectRatio?: number;
}
